import Register from "../_components/auth/Register";
import Terms from "../_components/Tc/Terms";
import LoginPage from "../_pages/LoginPage";
import { GoogleOAuthProvider } from '@react-oauth/google';

const PublicRoutes = [
  {
    path: "/login",
    element:  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}> <LoginPage /> </GoogleOAuthProvider>,
  },
  {
    path: "/signup",
    element: <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}> <Register /> </GoogleOAuthProvider>,
  },
 
];

export default PublicRoutes;
